export enum LandingSection {
  SERVICES = 'services',
  HOW_IT_WORKS = 'how-it-works',
  BENEFITS = 'benefits',
  USE_CASES = 'use-cases'
}
